import React, { useState } from 'react';
import Image from 'swag-client-common/components/ui/image';
import { is1024andSmaller } from 'swag-client-common/utils/ui.utils';
import Color from 'swag-client-common/components/ui/color';
import BoxDetailsBlock from '../box-details-block';
import BottomButtons from '../bottom-buttons';
import classes from './colored-box-selection.scss';
const MOBILE_MAX = 6;
const DESKTOP_MAX = 15;
function chunkArray(array, size) {
  let index = 0;
  const arrayLength = array.length;
  const tempArray = [];
  for (index = 0; index < arrayLength; index += size) {
    const chunk = array.slice(index, index + size);
    // @todo. auto generated. fix this error
    // @ts-ignore
    tempArray.push(chunk);
  }
  return tempArray;
}
function getMaxCount(length, max) {
  let count = max + 1;
  let divider = 1;
  while (count >= max) {
    count = Math.ceil(length / divider);
    divider++;
  }
  return count;
}
export default function ColorBoxSelection(props) {
  const {
    onNext,
    onBackButton,
    selectedBoxData: {
      pricePerBox,
      assemblyFee,
      productionTimeDays,
      img,
      name,
      description,
      additionalProductionTimeText,
      type
    },
    isBoxTypeEdit,
    selectedColor,
    colorsToChoose,
    onChange
  } = props;
  const [currentColor, setColorObject] = useState(colorsToChoose.find(colorObject => selectedColor === colorObject.color) || colorsToChoose[0]);
  const calculateColorsRows = colors => {
    const isMobile = is1024andSmaller();
    if (colors.length <= MOBILE_MAX) {
      return [colors];
    }
    const maxCount = isMobile ? getMaxCount(colors.length, MOBILE_MAX) : getMaxCount(colors.length, DESKTOP_MAX);
    return chunkArray(colors, maxCount);
  };
  const renderColorsRow = colors => /*#__PURE__*/React.createElement("div", {
    className: classes.colorRow
  }, colors.map(colorObject => {
    const {
      color,
      name
    } = colorObject;
    return /*#__PURE__*/React.createElement(Color, {
      key: name,
      showTooltip: true,
      name: name,
      color: color,
      className: classes.color,
      activeClassName: classes.activeColor,
      clickableClassName: classes.hoverColor,
      isActive: color === currentColor.color,
      isActionable: color !== currentColor.color,
      onClick: () => {
        setColorObject(colorObject);
        onChange(colorObject.color);
      }
    });
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("h1", {
    className: classes.title
  }, "Select the color of your box!"), /*#__PURE__*/React.createElement("div", {
    className: classes.infoWrapper
  }, /*#__PURE__*/React.createElement(BoxDetailsBlock, {
    pricePerBox: pricePerBox,
    assemblyFee: assemblyFee,
    productionTimeDays: productionTimeDays,
    previewImage: currentColor.img,
    name: name,
    description: description,
    additionalProductionTimeText: additionalProductionTimeText,
    selectedBoxDataType: type
  }), /*#__PURE__*/React.createElement(Image, {
    src: img,
    alt: name,
    wrapperClassName: classes.imageWrapper
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.chooseColorWrapper
  }, /*#__PURE__*/React.createElement("h2", {
    className: classes.subtitle
  }, "What color box would you like?"), calculateColorsRows(colorsToChoose).map(colorsRow => renderColorsRow(colorsRow))), /*#__PURE__*/React.createElement(BottomButtons, {
    nextText: isBoxTypeEdit ? 'Save' : 'Continue'
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    buttonsWrapperClassName: classes.buttonsWrapper,
    onBackButton: onBackButton,
    isDisabledNextButton: false,
    onNextButton: () => onNext(currentColor.color, isBoxTypeEdit)
  }));
}